// LG2-login — native recompose of components/common/icpText (China-region ICP
// registration notice; the string is a legal registration line, not copy).
import { AppConfig } from '@/config/appConfig';

export const IcpText = () => {
  if (AppConfig.region !== 'china') {
    return null;
  }

  return (
    <div className="mt-2">
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-3xs text-muted-foreground underline-offset-4 hover:underline"
        data-testid="v4-icp-text"
      >
        AssessPrep 沪ICP备17051512号
      </a>
    </div>
  );
};
